import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { StoreType } from "../../../../../../../redux/store/store";
import CustomDateInput from "../../../../../../../Components/CustomInputs/CustomDateInput";
import { updateFirstStepDynamicFields } from "../../../../../../../redux/reducers/claimReducer";
import { handleShowErrorMessage } from "../../../../../../../redux/reducers/claimFieldErrorsReducer";
import { shouldRenderSpecField } from "../../../../../../../redux/reducers/visibilityMatrixesReducer";
import { Box } from "@mui/material";
import { Paragraph } from "@nn-design-system/react-component-library";

const WorkIncapacityDateOfClaimToField: React.FC = () => {
   const dispatch = useDispatch();

   const DateOfClaimToValueWorkIncapacity = useSelector(
      (state: StoreType) =>
         state.claimState.injuryDescriptionModelBase.injuryDescriptionModel.find(
            (model) => model.typeOfClaimEnum === 2
         )?.dateOfClaimTo
   );
   const visibilityMatrixes = useSelector(
      (state: StoreType) => state.visibilityMatrixesState
   );

   const claimFieldErrorsMessages = useSelector(
      (state: StoreType) => state.claimFieldErrorsState
   );

   return (
      <Box>
         <CustomDateInput
            labelText="Ukončení pracovní neschopnosti"
            name="DateOfClaimTo"
            value={DateOfClaimToValueWorkIncapacity || undefined}
            onChange={(val: string | null) => {
               dispatch(
                  updateFirstStepDynamicFields({
                     value: val,
                     field: "dateOfClaimTo",
                     typeOfClaimEnum: 2,
                  })
               );
            }}
            validationText={handleShowErrorMessage(
               "incapacity.DateOfClaimTo",
               claimFieldErrorsMessages
            )}
            dependencyValue={shouldRenderSpecField(
               "incapacity",
               "DateOfClaimTo",
               visibilityMatrixes
            )}
         />
         <Paragraph variant="Small" mt=".75rem" hasMargin={false}>
            Pokud ještě nedošlo k ukončení pracovní neschopnosti, vyplňte pouze
            její počátek.
         </Paragraph>
      </Box>
   );
};

export default WorkIncapacityDateOfClaimToField;
